import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import UsageTracker from 'MeetingsAdmin/tracking/UsageTracker';

// @ts-expect-error untyped import
import * as MeetingsUserActions from '../redux/actions/MeetingsUserActions';
import { View } from 'foundations-components/components/View';
import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import FixIntegrationWarning from './alerts/FixIntegrationWarning';
// @ts-expect-error untyped import
import MultipleCalendarWarning from './alerts/MultipleCalendarWarning';
import IndexUpgradeBanner from './alerts/IndexUpgradeBanner';
// @ts-expect-error untyped import
import JitaViewWarning from './alerts/JitaViewWarning';
import FixSchedulingPageWarning from './alerts/FixSchedulingPageWarning';
import MeetingsAdminHeader from './MeetingsAdminHeader';
import PaidMeetingsBanner from './banner/PaidMeetingsBanner';
// @ts-expect-error untyped import
import { paidMeetingsBannerSelector } from 'MeetingsAdmin/selectors/UserAttributesSelector';
// @ts-expect-error untyped import
import { getHasEditAllLinksScope } from '../selectors/AuthSelector';
import MeetingsLinksTableWrapper from './table/MeetingsLinksTableWrapper';
import useQueryParams from '../hooks/useQueryParams';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useLinkIdQueryParam = () => {
  const query = useQueryParams();
  const {
    linkId
  } = query;
  return linkId;
};
function CalendarIndexContainer({
  history,
  children
}) {
  const dispatch = useDispatch();
  const linkId = useLinkIdQueryParam();
  const hasViewedPaidMeetingBanner = useSelector(paidMeetingsBannerSelector);
  useEffect(() => {
    UsageTracker.track('pageViewSubScreen', {
      screen: 'admin',
      subscreen: 'dashboard'
    });
  }, []);
  const canEditAllLinks = useSelector(getHasEditAllLinksScope);
  useEffect(() => {
    if (canEditAllLinks) dispatch(MeetingsUserActions.fetchMeetingsUsersIds());
  }, [dispatch, canEditAllLinks]);
  const changeRoute = useCallback(path => {
    history.push(path);
  }, [history]);
  return /*#__PURE__*/_jsx(View, {
    "data-selenium-test": "meetings-index-container",
    children: /*#__PURE__*/_jsx(ListingPage, {
      pageLayout: "full-width",
      headerComponent: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(MeetingsAdminHeader, {
          routeToCreateMeetingLink: () => changeRoute('link/new'),
          "data-selenium-test": "calendar-index-container"
        }), !hasViewedPaidMeetingBanner && /*#__PURE__*/_jsx(PaidMeetingsBanner, {})]
      }),
      children: /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(IndexUpgradeBanner, {}), /*#__PURE__*/_jsx(FixIntegrationWarning, {}), /*#__PURE__*/_jsx(MultipleCalendarWarning, {}), /*#__PURE__*/_jsx(FixSchedulingPageWarning, {}), /*#__PURE__*/_jsx(JitaViewWarning, {}), /*#__PURE__*/_jsx(MeetingsLinksTableWrapper, {
          handleRouteChange: changeRoute
        }), linkId ? children : null]
      })
    })
  });
}
export default withRouter(CalendarIndexContainer);